export const EXCLUDE_CANONICALS = ["regulatory-disclosures"];
